import { ReactNode } from 'react';

import { Box, Flex, Heading, List, ListItem } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { ContentContainer } from '~/components/container';
import { SanityImage } from '~/components/sanity-image';
import { CompanyContent } from '~/features/companies/models/company';

export type PartnershipsSectionProps = {
  title: string;
  testimonialsSlot: ReactNode;
  partners: Array<Pick<CompanyContent, '_id' | 'name' | 'hifiLogo'>>;
  instructorsSlot: ReactNode;
};

export function PartnershipsSection({ title, testimonialsSlot, partners, instructorsSlot }: PartnershipsSectionProps) {
  return (
    <Flex
      as='section'
      bgColor='accent.sky.100'
      flexDir='column'
      gap={16}
      padding={{
        base: '40px 0px',
        xl: '80px 0px',
      }}
    >
      <ContentContainer>
        <Heading
          as='h2'
          mb={10}
          textAlign='center'
          size={{
            base: 'marketing-3xl',
            md: 'marketing-4xl',
          }}
        >
          {title}
        </Heading>
        <List
          display='grid'
          gap={6}
          gridAutoRows='88px'
          mb={6}
          gridTemplateColumns={{
            base: '1fr 1fr',
            md: 'repeat(auto-fit, minmax(204px, 1fr))',
          }}
        >
          {partners.map((partner) => {
            if (!partner.hifiLogo) return null;
            return (
              <Card
                key={partner._id}
                alignItems='center'
                as={ListItem}
                borderColor='gray.200'
                display='flex'
                justifyContent='center'
                p={4}
                width='100%'
              >
                <SanityImage
                  alt={partner.name}
                  image={partner.hifiLogo}
                  style={{
                    objectFit: 'contain',
                    maxWidth: '100%',
                    pointerEvents: 'none',
                  }}
                />
              </Card>
            );
          })}
        </List>
        {instructorsSlot}
      </ContentContainer>
      <ContentContainer borderColor='black' borderTop='1px solid' />
      <Box>{testimonialsSlot}</Box>
    </Flex>
  );
}
